<template>
  <v-select
    :options="filteredUsers"
    label="name"
    :reduce="(o) => o.id"
    :placeholder="placeholder"
    :multiple="multiple"
    v-model="selection"
  ></v-select>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, toRefs } from "vue";
import axios from 'axios';
const props = defineProps({
  multiple: {
    type: Boolean,
    default: false
  },
  placeholder: {
    type: String,
    default: null
  },
  excludeSelf: {
    type: Boolean,
    default: false
  },
  modelValue: {
    default: null
  }
});
const {
  multiple,
  placeholder,
  excludeSelf,
  modelValue
} = toRefs(props);
const emit = defineEmits(["update:modelValue"]);
const selection = computed({
  get: () => modelValue.value,
  set: (value) => emit("update:modelValue", value)
});
const users = ref([]);
const filteredUsers = computed(() => {
  if (excludeSelf.value) {
    return users.value.filter(user => !user.is_self);
  } else {
    return users.value;
  }
});
onMounted(async () => {
  const response = await axios.get(route('users.index'));
  users.value = response.data.data.map(u => ({
    ...u,
    label: `${u.name} - ${u.email}`
  })).sort((a, b) => a.label.localeCompare(b.label));
});
</script>
